import type { ActingParty, PersonInvolvement } from "../types/involvement.js";
import { isInvolvementHeldBy } from "./isInvolvementHeldBy.js";
import { isInvolvementLive } from "./isInvolvementLive.js";

/**
 * Whether this party, acting for this organisation, holds the person's live
 * designated-assessor involvement, which is what makes an assessment they
 * start the definitive one.
 */
export const isPartyDesignatedAssessor = (
  involvements: readonly Pick<
    PersonInvolvement,
    "kind" | "party" | "endedAt" | "expiresAt"
  >[],
  party: Pick<ActingParty, "userId" | "organisationId">,
  now: Date = new Date(),
): boolean =>
  involvements.some(
    (involvement) =>
      involvement.kind === "designated_assessor" &&
      isInvolvementLive(involvement, now) &&
      isInvolvementHeldBy(involvement, party),
  );
